/* eslint-disable import/prefer-default-export */

import moment from 'moment';

import {
  flow,
  lowerCase,
  upperFirst,
} from 'lodash/fp';

export const filterUnit = accomodationsFilter => (unit) => {
  const queryRegeExReplace = new RegExp(/[^a-z0-9åäö]/, 'igm');

  let unitTitle = (unit.display_name || unit.description_title) + (unit.subtitle ? (` - ${unit.subtitle}`) : '');
  unitTitle = unitTitle.toLowerCase();
  unitTitle = unitTitle.replaceAll(queryRegeExReplace, '');

  let titleMatching = true;

  if (accomodationsFilter.freeSearch) {
    let query = accomodationsFilter.freeSearch.toLowerCase();
    query = query.replaceAll(queryRegeExReplace, '');
    titleMatching = unitTitle.match(new RegExp(query, 'igm'));
  }

  let locationMatching = true;
  if (accomodationsFilter.locationId) {
    const areaText = accomodationsFilter.locationId.toString().substr(0, 5);
    const area = accomodationsFilter.locationId.toString().substr(5);
    if (areaText === 'area-') {
      locationMatching = unit.facility_id === parseInt(area, 10);
    } else {
      locationMatching = unit.pool.id === accomodationsFilter.locationId;
    }
  }

  let dateMatching = true;
  if (accomodationsFilter.date.startDate && accomodationsFilter.date.endDate) {
    const ids = Object.keys(accomodationsFilter.availabelIds);
    if (ids && ids.length) {
      dateMatching = ids.indexOf(`${unit.id}`) !== -1;
    }
  }

  let bedMatching = true;
  if (accomodationsFilter.beds > 1) {
    bedMatching = (unit.beds + (unit.extra_beds || 0)) >= accomodationsFilter.beds;
  }

  let bedRoomMatching = true;
  if (accomodationsFilter.bedrooms > 1) {
    bedRoomMatching = unit.bedrooms >= accomodationsFilter.bedrooms;
  }

  // Lock filters
  let digitalIncheckMatch = true;

  if (window.SITE_CONFIG.settings.SettingLockTypes.active) {
    digitalIncheckMatch = !accomodationsFilter.direct_incheck || unit.lock_type_id;
  } else {
    digitalIncheckMatch = !accomodationsFilter.direct_incheck || unit.direct_incheck;
  }

  return (
    bedMatching
    && bedRoomMatching
    && (!accomodationsFilter.sauna || unit.sauna)
    && digitalIncheckMatch
    && (!accomodationsFilter.pets || unit.pets_allowed)
    && (!accomodationsFilter.chargeStation || unit.charging_post)
    && (!accomodationsFilter.cleaning || unit.final_cleaning_included)
    && (!accomodationsFilter.fireplace || unit.fireplace)
    && (!accomodationsFilter.dishwasher || unit.dishwasher)
    && (!accomodationsFilter.dryer_cabinet || unit.dryer_cabinet)
    && (!accomodationsFilter.washing_machine || unit.washing_machine)
    && (!accomodationsFilter.internet || unit.internet)
    && (!accomodationsFilter.child_friendly || unit.child_friendly)
    && locationMatching
    && dateMatching
    && titleMatching
    // TODO: Add `distance_to_skilift` filter
    // TODO: Add text search filter (name of unit or pool)
    // TODO: Add date filter (start and end date)
    // TODO: Add pool filter (via map)
  );
};

export const titleCase = flow([
  lowerCase,
  upperFirst,
]);

/* eslint-disable */
export const dayCountExcludeClosed = (start, end) => {
  if (!start || !end) {
    return 0;
  }

  const range = moment.range(start, end);
  const validDays = [];

  for (let day of range.by('day')) {
    let formatted = day.format('YYYY-MM-DD');
    if (window.SITE_CONFIG.season.winter.closed.indexOf(formatted) === -1) {
      validDays.push(formatted);
    }
  }

  return validDays.length;
};

export const hasClosedDaysInRange = (start, days) => {
  if (!start || !days) {
    return false;
  }

  const newEnd = moment(start).add((days - 1), 'days');

  const range = moment.range(start, newEnd);
  const invalidDays = [];

  for (let day of range.by('day')) {
    let formatted = day.format('YYYY-MM-DD');
    if (window.SITE_CONFIG.season.winter.closed.indexOf(formatted) > -1) {
      invalidDays.push(formatted);
    }
  }

  return invalidDays.length ? true : false;
};

export const endDateIncludeClosed = (start, days) => {
  if (!start) {
    return null;
  }
  if (!days) {
    return null;
  }

  if (days <= 1) {
    return null;
  }
  
  const newStart = moment(start);
  let day = newStart.clone();
  let dayCount = 0;
  let iterations = 0;

  while (dayCount < days && iterations <= 180) {
    iterations += 1;
    day.add(1, 'days');
    let formatted = day.format('YYYY-MM-DD');
    if (window.SITE_CONFIG.season.winter.closed.indexOf(formatted) === -1) {
      dayCount += 1;
    }
  }

  return day.subtract(1, 'days');
};
/* eslint-enable */

export const formatAccomodationsFilterDate = (startDate, endDate) => (
  `${moment(startDate).format('D/M')} – ${moment(endDate).format('D/M')}`
);



// WEBPACK FOOTER //
// ./src/lib/index.js